import {FormProps} from "../shared/types";
import {SimpleForm, TextInput} from "react-admin";
import {initInput} from "../shared/utils";


export const TagForm = (props: FormProps) => {
    return (
        <SimpleForm {...props}>
            <TextInput {...initInput("name", props.fieldOptions)} />
            <TextInput {...initInput("description", props.fieldOptions)} />
        </SimpleForm>
    )
}